<template>
	<div class="template table" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div>
			<div class="title" >{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.deleteIsShow" @click="deleteTable(dataVal.Property.Title[0].Text)">删除</span></div>
			<div v-for='(item,index) in dataVal.Config.Table.Children' :key='index'>
				<digit v-if='item.Property.Control=="Number"' :data-val='item'></digit>
				<contact v-if='item.Property.Control=="Condition"' :data-val="item"></contact>
				<dates v-if='item.Property.Control=="Date"' :data-val="item"></dates>
				<version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></version>
				<money v-if='item.Property.Control=="Money"' :data-val="item"></money>
				<tips v-if='item.Property.Control=="Tips"' :data-val="item"></tips>
				<file v-if='item.Property.Control=="File"' :data-val="item"></file>
				<selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></selector>
				<textArea v-if='item.Property.Control=="Textarea"' :data-val='item'></textArea>
			</div>
		</div>
		<div v-show="dataVal.addIsShow==null||dataVal.addIsShow" class="add-table" @click="addTable(dataVal.Property.Title[0].Text)">
			<span></span>
			添加明细
		</div>
	</div>
</template>

<script>
	// import Digit from '../components/Number.vue'
	// import Contact from '../components/Contact.vue';
	// import Date from '../components/Date.vue';
	// import Version from '../components/Text.vue';
	// import Money from '../components/Money.vue';
	// import Tips from '../components/Tips.vue';
	// import File from '../components/File.vue';
	// import Selector from '../components/Selector.vue';
	// import Textarea from '../components/Textarea.vue';
	import stringUtils from "../../assets/js/stringUtil.js";
	
	export default {
		// components: {
		// 	Contact,
		// 	Date,
		// 	Version,
		// 	Money,
		// 	Tips,
		// 	File,
		// 	Digit,
		// 	Selector,
		// 	Textarea
		// },
		props: ['dataVal'],
		data() {
			return {

			}
		},
		created() { //页面挂载
			this.$set(this.dataVal, 'addIsShow', stringUtils.getAddIsShow())
		},
		methods: { //方法
			getTextVal() {
			},
			getSelectorVal(val,name) {
				var selectVal = "";
				var selectVal1 = "";
				var children = this.dataVal.Config.Table.Children;
				var i = 0;
				var j = 0;
				if (name == "是否存在已开发票未回收情况") {
					var IsShow=false;
					var controlInfo = children.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "是"&&item.Key==val;
						})[0];
					var numControl = children.filter(item => item.Property.Title[0].Text == "发票编号")[0]
					if (option != null) {
						IsShow=true;
					} 
					numControl.IsShow = IsShow;
					numControl.Property.Require = IsShow?1:0;
				}
				
				
				// console.log(val)
				if(name == "公司"){
					if(val!=null){
						for(i = 0; i < children.length;i++){
							children[i].Property.Require = 0;
						}
						for(i = 0; i < children.length;i++){
							if(children[i].Property.Title[0].Text=="公司"){
								for(j = 0;j<children[i].Config.Selector.Options.length;j++){
									if(val == children[i].Config.Selector.Options[j].Key){
										selectVal = children[i].Config.Selector.Options[j].Value[0].Text;
										break;
									}
								}
							}else if(children[i].Property.Title[0].Text=="类型"||children[i].Property.Title[0].Text=="印章类型"){
								var options = children[i].Config.Selector.Options;
								if(children[i].Property.Title[0].Text=="类型"){
									for(j=0;j<options.length;j++){
										options[j].IsShow=false;
									}
									if(children[i].Value == ''){
										children[i].Value = null
									}else{
										children[i].Value = ''
									}
									children[i].Values = null;
								}
								if(selectVal=="四川中原物业顾问有限公司"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="台港澳侨投资企业批准证书"||
											options[j].Value[0].Text=="一般纳税人通知书"||
											options[j].Value[0].Text=="房地产经纪机构等级证书"||
											options[j].Value[0].Text=="其他"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="成都分公司"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="一般纳税人资格登记表"||
											options[j].Value[0].Text=="其他"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="汇瀚"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="台港澳侨投资企业批准证书"||
											options[j].Value[0].Text=="章程"||
											options[j].Value[0].Text=="其他"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="房友圈"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="一般纳税人资格登记表"||
											options[j].Value[0].Text=="其他"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="地产代理"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="一般纳税人通知书"||
											options[j].Value[0].Text=="房地产经纪机构等级证书"||
											options[j].Value[0].Text=="其他"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="重庆港深汇房地产代理有限公司"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"||
											options[j].Value[0].Text=="备案证书正本"||
											options[j].Value[0].Text=="备案证书副本"||
											options[j].Value[0].Text=="一般纳税人通知书"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="四川原友信律师事务所"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="营业执照正本"||
											options[j].Value[0].Text=="营业执照副本"||
											options[j].Value[0].Text=="开户许可证"){
											options[j].IsShow=true;
										}
									}
								}else if(selectVal=="法人证件"){
									for(j=0;j<options.length;j++){
										if(options[j].Value[0].Text=="庄总身份证"||
											options[j].Value[0].Text=="庄总通行证"||
											options[j].Value[0].Text=="何总身份证"||
											options[j].Value[0].Text=="何总通行证"||
											options[j].Value[0].Text=="何总经纪人资格证书"||
											options[j].Value[0].Text=="蒋燕身份证"){
											options[j].IsShow=true;
										}
									}
								}
								if(selectVal!="分行"){
									children[i].Property.Require = 1;
								}
							}else if(children[i].Property.Title[0].Text.indexOf("备注")>=0&&selectVal=="分行"){
								children[i].Property.Require = 1;
							}
						}
					}
				}else if(name == "类型"){
					if(val!=null){
						var selectVal2 = "";
						for(i = 0; i < children.length;i++){
							if(children[i].Property.Title[0].Text=="公司"){
								for(j = 0;j<children[i].Config.Selector.Options.length;j++){
									if(children[i].Value == children[i].Config.Selector.Options[j].Key){
										selectVal2 = children[i].Config.Selector.Options[j].Value[0].Text;
										break;
									}
								}
							}else if(children[i].Property.Title[0].Text==name){
								for(j = 0;j<children[i].Config.Selector.Options.length;j++){
									if(val == children[i].Config.Selector.Options[j].Key){
										selectVal1 = children[i].Config.Selector.Options[j].Value[0].Text;
										break;
									}
								}
							}else if(children[i].Property.Title[0].Text.indexOf("备注")>=0){
								
								if(selectVal1=="其他"){
									children[i].Property.Require = 1;
								}else{
									if(selectVal2!="分行"){
										children[i].Property.Require = 0;
									}
								}
								
							}
						}
					}else{
						for(i = 0; i < children.length;i++){
							children[i].Property.Require = 0;
						}
					}
				}
				
				this.$forceUpdate()
			},
			deleteTable(val){
				this.$emit('child-event', val,"delete",this.dataVal);
			},
			addTable(val){
				this.$emit('child-event', val,"add",this.dataVal);
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';

	.table {
		border-bottom: 1px solid #eee;
		margin-top: 0;
	}

	.table .template {
		margin-top: 0;
		padding-left: 10px;
		padding-right: 6px;
	}

	.table .panel_wrap {
		padding: 10px 7px;
		border-bottom: 1px solid #eee;
	}
</style>
